import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEdit,
  faTimes,
  faEnvelope,
  faQuestionCircle,
  faFilter,
  faAngleUp,
  faAngleDown,
  faAngleRight,
  faArrowDown,
  faArrowLeft,
  faFilePdf,
  faCircleQuestion,
  faCircleInfo,
  faPenSquare,
  faUndo,
  faDollarSign,
  faBuilding,
  faBuildingCircleXmark,
  faUserPlus,
  faCartShopping,
  faWarning,
  faTrash,
  faPlus,
  faMinus,
  faDownload,
  faUsers,
  faCubes,
  faDatabase,
  faFileImage,
  faAlignLeft,
  faStar,
  faBullhorn,
  faShare,
  faSync,
  faNoteSticky,
  faCheck,
  faFile,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faArrowUpRightFromSquare,
  faSliders,
  faClipboardList,
  faGripLines,
  faGripLinesVertical,
  faCircleExclamation,
  faPrint,
  faSave,
  faPlusCircle,
  faMinusCircle,
  faTasks,
  faClock,
  faComment,
  faSeedling,
  faBox,
  faCalendar,
  faHistory
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faEdit,
  faTimes,
  faEnvelope,
  faQuestionCircle,
  faFilter,
  faAngleUp,
  faAngleDown,
  faArrowDown,
  faArrowLeft,
  faFilePdf,
  faCircleQuestion,
  faCircleInfo,
  faPenSquare,
  faUndo,
  faDollarSign,
  faBuilding,
  faBuildingCircleXmark,
  faUserPlus,
  faCartShopping,
  faWarning,
  faTrash,
  faPlus,
  faMinus,
  faDownload,
  faUsers,
  faCubes,
  faDatabase,
  faFileImage,
  faAlignLeft,
  faStar,
  faBullhorn,
  faShare,
  faAngleRight,
  faSync,
  faNoteSticky,
  faCheck,
  faFile,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faArrowUpRightFromSquare,
  faSliders,
  faClipboardList,
  faGripLines,
  faGripLinesVertical,
  faCircleExclamation,
  faPrint,
  faSave,
  faPlusCircle,
  faMinusCircle,
  faTasks,
  faClock,
  faComment,
  faSeedling,
  faBox,
  faCalendar,
  faHistory
);

export default FontAwesomeIcon;
